import PropTypes from 'prop-types'
import { Box, Button, FormControl, FormLabel, Grid, IconButton, NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, Text } from '@chakra-ui/react'
import { MdOutlineDelete } from 'react-icons/md'
import {
  STACK_MODES,
  STRUCTURE_COMPONENT_TYPES,
  createStructureComponent,
  parseStructureComponents
} from 'lib'
import { StackModeField } from './StackModeField'

export const ExtraStructureComponents = ({ form, setForm, type }) => {
  const components = parseStructureComponents(form.structureComponents)
  const items = components.filter(item => item.type === type)
  const isEmc = type === STRUCTURE_COMPONENT_TYPES.Emc
  const addLabel = isEmc ? 'Add another EMC' : 'Add another ID Cabinet'

  const updateComponents = (next) => {
    setForm(draft => {
      draft.structureComponents = next
    })
  }

  const handleChange = (id, field, value) => {
    updateComponents(components.map(item => (
      item.id === id ? { ...item, [field]: value } : item
    )))
  }

  const handleDelete = (id) => {
    updateComponents(components.filter(item => item.id !== id))
  }

  const handleAdd = () => {
    updateComponents([...components, createStructureComponent(type, components)])
  }

  return (
    <Box mt={4}>
      {items.map((item, index) => (
        <Grid
          key={item.id ?? `extra-${type}-${index}`}
          templateColumns="auto repeat(3, 1fr)"
          gap={3}
          mb={3}
          alignItems="flex-end"
        >
          <IconButton
            size="sm"
            colorScheme="gray"
            aria-label="Remove component"
            icon={<MdOutlineDelete fontSize="16px" />}
            onClick={() => handleDelete(item.id)}
            mb={1}
          />
          {isEmc ? (
            <>
              <FormControl>
                <FormLabel>Module Height (ft)</FormLabel>
                <NumberInput
                  min={0}
                  value={item.modsH || 0}
                  onChange={(v) => handleChange(item.id, 'modsH', parseInt(v) || 0)}
                >
                  <NumberInputField />
                  <NumberInputStepper>
                    <NumberIncrementStepper />
                    <NumberDecrementStepper />
                  </NumberInputStepper>
                </NumberInput>
              </FormControl>
              <FormControl>
                <FormLabel>Module Length (ft)</FormLabel>
                <NumberInput
                  min={0}
                  value={item.modsL || 0}
                  onChange={(v) => handleChange(item.id, 'modsL', parseInt(v) || 0)}
                >
                  <NumberInputField />
                  <NumberInputStepper>
                    <NumberIncrementStepper />
                    <NumberDecrementStepper />
                  </NumberInputStepper>
                </NumberInput>
              </FormControl>
            </>
          ) : (
            <>
              <FormControl>
                <FormLabel>Height (in)</FormLabel>
                <NumberInput
                  min={0}
                  value={item.heightIn || 0}
                  onChange={(v) => handleChange(item.id, 'heightIn', parseInt(v) || 0)}
                >
                  <NumberInputField />
                  <NumberInputStepper>
                    <NumberIncrementStepper />
                    <NumberDecrementStepper />
                  </NumberInputStepper>
                </NumberInput>
              </FormControl>
              <FormControl>
                <FormLabel>Length (in)</FormLabel>
                <NumberInput
                  min={0}
                  value={item.lengthIn || 0}
                  onChange={(v) => handleChange(item.id, 'lengthIn', parseInt(v) || 0)}
                >
                  <NumberInputField />
                  <NumberInputStepper>
                    <NumberIncrementStepper />
                    <NumberDecrementStepper />
                  </NumberInputStepper>
                </NumberInput>
              </FormControl>
            </>
          )}
          <StackModeField
            value={item.stackMode || STACK_MODES.Stacked}
            onChange={(v) => handleChange(item.id, 'stackMode', v)}
            label={`${isEmc ? 'EMC' : 'Cabinet'} ${index + 2} Position`}
          />
        </Grid>
      ))}
      <Box>
        <Button size="sm" variant="outline" onClick={handleAdd}>{addLabel}</Button>
        <Text fontSize="xs" color="gray.500" mt={1}>
          Extra {isEmc ? 'EMCs' : 'cabinets'} count toward overall height and square footage. Add matching Additional Items if they affect pricing.
        </Text>
      </Box>
    </Box>
  )
}

ExtraStructureComponents.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func,
  type: PropTypes.oneOf([STRUCTURE_COMPONENT_TYPES.Emc, STRUCTURE_COMPONENT_TYPES.Cabinet])
}
